import {
    bindable,
    BindingEngine,
    customElement,
    inject,
    InlineViewStrategy,
    LogManager,
    PLATFORM
} from "aurelia-framework";
import {ConditionMatcher} from "../../condition-builder/condition-matcher.js";
import {ModuleConfigClient} from "../../api/module-config-client.js";
import {UserClient} from "../../api/user-client";
import * as _ from 'lodash';

const logger = LogManager.getLogger('Panel');

@customElement('sio-panel')
@inject(
    ConditionMatcher,
    ModuleConfigClient,
    UserClient,
    BindingEngine,
)
export class Panel {
    @bindable config;
    @bindable object;

    @bindable onPinChange = undefined;

    _config;
    showWithoutPermission = false;

    constructor(
        matcher,
        configClient,
        userClient,
        bindingEngine,
    ) {
        this.matcher = matcher;
        this.configClient = configClient;
        this.userClient = userClient;
        this.bindingEngine = bindingEngine;

        this.showWithoutPermission = this.userClient.showWithoutPermission;

        // Observe changes in contentLocale
        this.subscription = this.bindingEngine.propertyObserver(this.userClient, 'showWithoutPermission')
            .subscribe((showWithoutPermission) => {
                this.showWithoutPermission = showWithoutPermission;
            });
    }

    dispose() {
        if (this.subscription) {
            this.subscription.dispose();
        }
    }

    async bind(context, overrideContext) {
        this.context = context;
        this.overrideContext = overrideContext;

        if (this.object == null) {
            return;
        }

        this._config = "string" !== typeof this.config ? this.config :
            (await this.configClient.getModel(this.object.modelId)).display.panels.find(panel => panel.id === this.config);

        if (!this._config) {
            return;
        }

        this._config = Object.assign({hidden: false}, this._config);
        if (this._config.hasOwnProperty("customBody")) {
            this._config.viewStrategy = new InlineViewStrategy('<template>' + this._config.customBody + '</template>');
        }

        if (this._config.hasOwnProperty("customHeader")) {
            this._config.headerViewStrategy = new InlineViewStrategy('<template>' + this._config.customHeader + '</template>');
        }

        logger.debug('Binding changed', this);
    }

    displayProperties(config) {
        return config.fields.map(field => field.id);
    }

    _getContext(object) {
        if (this._config.hasOwnProperty('actionContext')) {
            return this._config.actionContext;
        }

        // deep clone here, not using json because of bugs
        const context = _.cloneDeep(object);

        if (!context.hasOwnProperty('contextObjectRef') || !context.contextObjectRef.hasOwnProperty('id')) {
            context.contextObjectRef = {
                id: object.id,
                modelId: object.modelId,
            };
        }

        if (context.content) {
            console.log('Warning content property provided, deleting as it breaks views for cms detail pages');
            //Bugfix for cms-page detail page, where content of page overwrites view content
            delete context.content;
        }

        return context;
    }
}

PLATFORM.moduleName('view/view-container');
